import Footer from './desktop/Footer';
import FooterMobile from './mobile/FooterMobile';
import 'portalConfig';

export default angular.module('customerEdge.footer.module', ['portal.config'])
    .component('gwFooter', Footer)
    .component('gwFooterMobile', FooterMobile);
